export function stringIsNullOrEmpty(value) {
    if (value == null || value == undefined) return true
    else if (value.toString().trim().length == 0) return true
    else return false
}

export function integerOnly(value, minValue = undefined, defaultValue = undefined) {
    var intValue = parseInt(value.replace(/\D/, ''))
    if (intValue == undefined || isNaN(intValue)) {
        if (defaultValue != undefined) return defaultValue
        else return ''
    }
    else if (minValue != undefined) if (minValue > intValue) return minValue

    return intValue
}

export function decimalOnly(value, minValue = undefined, maxValue = undefined) {
    if (value == '.') {
        return '0.'
    }
    if (String(value).endsWith('.')) {
        var decimalNumber = true
    }
    if (String(value).includes('.')) {
        var decimalSlice = String(value).split('.')[1]
        decimalSlice = String(decimalSlice).slice(0, 2)
        decimalSlice = numberOnly(decimalSlice, 2)
    }
    var integerSlice = String(value).split('.')[0]
    integerSlice = integerOnly(integerSlice)
    value = integerSlice
    if (decimalSlice != undefined) {
        value = String(value).concat('.', decimalSlice)
        if (minValue != undefined && parseFloat(value) < parseFloat(minValue)) return minValue
        else if (maxValue != undefined && parseFloat(value) > parseFloat(maxValue)) return maxValue
        else return value
    } else if (decimalNumber != undefined) {
        value = String(value).concat('.')
        if (minValue != undefined && parseFloat(value) < parseFloat(minValue)) return minValue
        else if (maxValue != undefined && parseFloat(value) > parseFloat(maxValue)) return maxValue
        else return value
    }
    else {
        if (minValue != undefined && parseFloat(value) < parseFloat(minValue)) return minValue
        else if (maxValue != undefined && parseFloat(value) > parseFloat(maxValue)) return maxValue
        else return value
    }
}

export function numberOnly(value, size, minValue = undefined, maxValue = undefined) {
    if (minValue != undefined && parseInt(value) < parseInt(minValue)) {
        return minValue
    }
    if (maxValue != undefined && parseInt(value) > parseInt(maxValue)) {
        return maxValue
    }
    if (value.length > size) {
        value = String(value).slice(0, size)
    }
    if (isNumber(value, size)) {
        return value
    }
    else {
        return value.replace(/\D/, '')
    }
}

export function letterOnly(value) {
    if (lettersOnly(value)) {
        return String(value).replace(/[\u0300-\u036f]/g, '')
    }
    else {
        return value.replace(/(?![\&\¿\?\¡\!\.\-\sA-z\u00c0-\u00ff])[\u0000-\uffff]/, '')
    }
}

export function emailOnly(value) {
    if (isEmail(value)) {
        return String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    }
    else {
        return value.normalize('NFD').replace(/(?![\w@.])[\u0000-\uffff]/, '')
    }
}

export function dateOnly(value) {
    if (isDate(value)) {
        return value
    }
    return value

}

export function noSpecials(value) {
    if (noSpecialCharacters(value)) {
        return String(value).replace(/[\u0300-\u036f]/g, '')
    }
    else {
        return value.replace(/(?![\.\-\s\w\u00c0-\u00ff])[\u0000-\uffff]/, '')
    }
}

export function lettersOnly(value) {
    var re = /^[\&\¿\?\¡\!\.\-\sA-z\u00c0-\u00ff]*$/;
    return re.test(String(value));
}

export function noSpecialCharacters(value) {
    var re = /^[\.\-\s\w\u00c0-\u00ff]*$/;
    return re.test(String(value));
}

export function isEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email));
}

export function isPhone(phone) {
    var re = /^([0-9]{7}|[0-9]{9})$/;
    return re.test(String(phone).toLowerCase());
}

export function isNumber(value, size) {
    var re = /^[0-9]*$/;
    return re.test(String(value).toLowerCase()) && value.length == size;
}

export function isMoney(value) {
    var re = /^(?!0*\.*0*$)([1-9][0-9]*|[0-9]*(\.[0-9]{0,2})?)$/;
    return re.test(String(value).toLowerCase());
}

export function isPositive(value) {
    var re = /^(?!0*$)([1-9][0-9]*)$/;
    return re.test(String(value).toLowerCase());
}

export function isDate(value) {
    var re = /^((0?[1-9]|[12][0-9]|3[01])[- /.](0[1-9]|1[012])[- /.](19|20)?[0-9]{2})$/;
    return re.test(String(value).toLowerCase());
}

export function isOffer(value) {
    var re = /^([0-9]*(\.[0-9]{0,2})?)$/;
    return re.test(String(value).toLowerCase());
}

export function arrayIsNullOrEmpty(array) {
    if (array == null || array == 'undefined') return false
    else if (array.length <= 0) return false
    else return true
}

export function isDefaultSelected(value) {
    if (value == 0) return true
    return false
}

export function isValueAcepted(value) {
    if (value == 0) return false;
    return true
}


// WEBPACK FOOTER //
// ./src/common/helpers/validation.js